import React, { Component, setState, useState, useEffect } from "react";
import { BrowserRouter, Route, Routes,useLocation } from "react-router-dom";
import LayoutComponent from "./components/LayoutComponent";
import HomeContainer from "../Home/HomeContainer";
import AboutContainer from "../About/AboutContainer";
import ServicesContainer from "../Services/ServicesContainer";
import ContactContainer from "../Contact/ContactContainer";
import PaigesVinesContainer from "../Demo/PaigesVinesContainer";
import AdminContainer from "../Admin/AdminContainer";
import { ClientStyles } from "../Styles/ClientStyles";
import WinerySampleContainer from "../WinerySample/WinerySampleContaner";



export class LayoutContainer extends Component {
    constructor (props){
        super(props)
        this.state = {
            // set any states we need for layout here
            // this is probably where we would set the design
            styleSetting:'compris',
            activeTab:window.location.pathname,
            /** main feature is website, demo is for wine-demo, admin is for admin-demo */
            feature:'main'
        };
        this.updateActiveTab = this.updateActiveTab.bind(this);
        this.updateFeature = this.updateFeature.bind(this);
      }
      updateActiveTab(tab){
        this.setState({activeTab:tab});
      }
      updateFeature(feature){
        this.setState({feature:feature});
      }
 
    
        
    render() {
        
        return(
        <>
            <BrowserRouter>
                <LayoutComponent 
                    tab={this.state.activeTab} updateTab={this.updateActiveTab}  
                    feature={this.state.feature} updateFeature={this.updateFeature} 
                >
                    <Routes>
                        <Route path='/Home' element={<HomeContainer />}/>
                        <Route path='/' element={<HomeContainer />}/>
                        <Route path='/About' element={<AboutContainer/>}/>
                        <Route path='/Services' element={<ServicesContainer tab={this.state.activeTab} updateTab={this.updateActiveTab}/>}/>
                        <Route path='/Contact' element={<ContactContainer/>}/>
                        <Route path='/Demo' element={<WinerySampleContainer tab={this.state.activeTab} updateTab={this.updateActiveTab}/>}/>
                        <Route path='/AdminDemo' element={<AdminContainer tab={this.state.activeTab} updateTab={this.updateActiveTab}/>}/>
                    </Routes>
                </LayoutComponent>
            </BrowserRouter>
        </>
            
        );
    }  
}

LayoutContainer.defaultProps={

}
LayoutContainer.propTypes = {

}

export default(LayoutContainer);